import { render, staticRenderFns } from "./HomeInfo.vue?vue&type=template&id=bff82478&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=ts"
export * from "./HomeInfo.vue?vue&type=script&lang=ts"
import style0 from "./HomeInfo.vue?vue&type=style&index=0&id=bff82478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff82478",
  null
  
)

export default component.exports